<template>
  <div :class="classes">
     <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" :current-page="currentPage" isAddPageToRouter v-loading="loading" ref="table">
        <wt-table :labels="tableLabels" :list="tableData">
          <slot/>
        </wt-table>
     </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-link-manage-table'

export default {
  name: 'pt-link-manage-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    totalNumber: Number,
    pageSize: Number,
    currentPage: Number,
    loading: Boolean,
    tableLabels: Array,
    tableData: Array
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
